import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-attribute-readonly',
    templateUrl: './attribute-readonly.component.html',
    standalone: false
})
export class AttributeReadonlyComponent {
    @Input() label: string | undefined;
    @Input() value: string | string[] | number | undefined | null;
}
